"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Performance() {
  const {
    ref: headRef,
    isVisible: headVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const testimonials = [{
    quote: "Sunil transformed our OTA strategy, resulting in a 25% increase in direct bookings and significantly improved revenue margins.",
    studio: "Grand Plaza Hotel",
    role: "General Manager"
  }, {
    quote: "His deep knowledge of hospitality tech stacks helped us streamline our operations and reduce manual overhead by 40%.",
    studio: "Urban Boutique Suites",
    role: "Owner & Investor"
  }, {
    quote: "The revenue audit provided by Sunil was eye-opening. We identified hidden leaks and optimized our pricing for peak seasons.",
    studio: "Coastal Resort Group",
    role: "Revenue Director"
  }];
  return <section data-section-id="7359" id="performancemetricsandtestimonials" className="bg-background text-foreground py-24 md:py-36">
      <div className="mx-auto max-w-[1440px] px-6 md:px-12">
        {}
        <div ref={headRef} className="grid grid-cols-12 gap-6 md:gap-8 items-end" style={{
        opacity: headVisible ? 1 : 0,
        transform: headVisible ? "translateY(0)" : "translateY(16px)",
        transition: "opacity 700ms cubic-bezier(0.2,0.8,0.2,1), transform 700ms cubic-bezier(0.2,0.8,0.2,1)"
      }}>
          <div className="col-span-12 md:col-span-8 relative">
            <span className="block font-serif text-primary" style={{
            fontSize: "clamp(5rem, 22vw, 22rem)",
            fontWeight: 380,
            letterSpacing: "-0.05em",
            lineHeight: 0.82,
            fontVariationSettings: headVisible ? '"wght" 380, "wdth" 100' : '"wght" 320, "wdth" 90',
            transition: "font-variation-settings 900ms cubic-bezier(0.2,0.8,0.2,1)"
          }}>
              35%
            </span>
          </div>

          <div className="col-span-12 md:col-span-4 md:pb-4">
            <p className="font-default text-muted-foreground" style={{
            fontSize: "clamp(1.125rem, 1.3vw, 1.375rem)",
            fontWeight: 380,
            lineHeight: 1.45,
            letterSpacing: "-0.005em"
          }}>
              average revenue growth for{" "}
              <span className="text-foreground font-serif italic" style={{
              fontWeight: 420,
              fontVariationSettings: '"wght" 420, "wdth" 100'
            }}>
                50+ hotels
              </span>{" "}
              since 2020.
            </p>
          </div>
        </div>

        {}
        <div ref={gridRef} className="mt-16 md:mt-24 grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((t, i) => <figure key={i} data-index={i} className="bg-card text-card-foreground rounded-md p-8 border border-border hover:border-primary" style={{
          opacity: gridVisible ? 1 : 0,
          transform: gridVisible ? "translateY(0)" : "translateY(20px)",
          transition: `opacity 600ms cubic-bezier(0.2,0.8,0.2,1) ${i * 90}ms, transform 600ms cubic-bezier(0.2,0.8,0.2,1) ${i * 90}ms, border-color 220ms ease-out`
        }}>
              <blockquote className="font-serif italic text-foreground" style={{
            fontSize: "clamp(1.25rem, 1.8vw, 1.625rem)",
            fontWeight: 420,
            lineHeight: 1.3,
            letterSpacing: "-0.015em"
          }}>
                {"\u201C"}{t.quote}{"\u201D"}
              </blockquote>

              <figcaption className="mt-6 flex flex-col gap-1">
                <span className="font-default text-foreground" style={{
              fontSize: "14px",
              fontWeight: 500,
              letterSpacing: "-0.005em"
            }}>
                  {t.studio}
                </span>
                <span className="font-mono text-muted-foreground flex items-center gap-2" style={{
              fontSize: "0.75rem",
              fontWeight: 450,
              letterSpacing: "0.02em",
              lineHeight: 1.3
            }}>
                  <span aria-hidden="true" className="inline-block w-1.5 h-1.5 rounded-lg bg-primary" />
                  {t.role}
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}